var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('legal-dialog'),_c('app-header',{on:{"onHide":_vm.hideNavigation}}),[(_vm.acceptedLegal)?_c('app-sidebar',{attrs:{"hide":_vm.drawer}}):_vm._e(),_c('v-main',[_c('mapbox-map')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }